module.exports = __webpack_public_path__ + "img/img_juxing@2x.7372eee7.png";